export default {
  methods: {
    GetShareURL: function (externalID) {
      return `${this.$store.state.frontURL}/show/${externalID}`;
    },
    GetSharePath: function (externalID) {
      return `/show/${externalID}`;
    },
    // uploaded, show, list
    ExecDirect: function (url) {
      if (this.execCopy(url, "direct-url-copy-button") === false) {
        return this.toastError("このブラウザは対応していません 😥");
      }
    },
    ExecShare: function (externalID) {
      const url = this.GetShareURL(externalID);
      if (this.execCopy(url, "share-url-copy-button") === false) {
        return this.toastError("このブラウザは対応していません 😥");
      }
    },
    execCopy: function (string, eleID) {
      let temp = document.createElement("div");
      temp.appendChild(document.createElement("pre")).textContent = string;
      let s = temp.style;
      s.position = "fixed";
      s.left = "-100%";
      document.body.appendChild(temp);
      document.getSelection().selectAllChildren(temp);
      let result = document.execCommand("copy");
      document.body.removeChild(temp);

      if (eleID !== "") {
        // イベントが発生した要素（クリックされたボタン）を特定
        const clickedButton = document.activeElement;

        // data-copy-id 属性を持つ要素かどうか確認
        if (
          clickedButton &&
          clickedButton.getAttribute("data-copy-id") === eleID
        ) {
          clickedButton.innerText = "コピーしました";
        } else {
          // 古い実装との互換性のため、ID で検索する方法も残しておく
          const button = document.getElementById(eleID);
          if (button) {
            button.innerText = "コピーしました";
          }
        }
      }

      return result;
    },
  },
};
